import { Head } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { TestimonialForm, type TestimonialData } from "./TestimonialForm"

const EMPTY: TestimonialData = {
  brand: "gisela",
  quote: "",
  attribution: "",
  display_order: 0,
  visible: true,
  highlighted: false,
}

export default function TestimonialsNew() {
  return (
    <AdminShell>
      <Head title="Add Testimonial">
        <meta name="description" content="Add a new client testimonial." />
        <meta property="og:title" content="Add Testimonial" />
        <meta property="og:description" content="Add a new client testimonial." />
      </Head>
      <PageHeader title="Add testimonial" />
      <div className="mt-8 max-w-2xl">
        <TestimonialForm
          testimonial={EMPTY}
          actionUrl="/admin/testimonials"
          method="post"
        />
      </div>
    </AdminShell>
  )
}
